<template>
  <div>
    <div class="wizard__header" v-html="this.header"></div>

    <div class="calculator wizard__calculator">
      <ul class="calculator__fields" v-equalizer>
        <li class="calculator__field calculator__field--rate">
          <div class="calculator__inside">
            <label class="calculator__label">Hourly Rate</label>
            <div class="calculator__value">${{ this.hourlyRate }}</div>
          </div>
        </li>
        <li class="calculator__field calculator__field--times">
          <div class="calculator__symbol">x</div>
        </li>
        <li class="calculator__field calculator__field--hours">
          <div class="calculator__inside">
            <label class="calculator__label"># of Hours</label>
            <input class="calculator__input" type="tel" ref="input" v-model="numOfHours" @keypress="hourKeypressHandler" />
          </div>
        </li>
        <li class="calculator__field calculator__field--equals">
          <div class="calculator__symbol">=</div>
        </li>
        <li class="calculator__field calculator__field--total">
          <div class="calculator__inside">
            <label class="calculator__label">Total Cost</label>
            <div class="calculator__value">${{ this.total }}</div>
          </div>
        </li>
      </ul>
    </div>

    <ul class="wizard__nav" v-if="onPrevious">
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Schedule Your Move</a></li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
        onResponse: {
            type: Function
        },

        onPrevious: {
            type: Function
        },

        header: {
            type: String
        },

        data: {
            type: Object,
            required: true
        },
    },

    data: () => ({
        hourlyRate: 150,
        numOfHours: 3
    }),

    computed: {
        total() {
            if (this.numOfHours != "" && this.numOfHours < 2) {
                this.numOfHours = 2;
            }

            if (this.numOfHours != "" && this.numOfHours > 5) {
                this.numOfHours = 5;
            }

            let total = this.numOfHours * this.hourlyRate;

            return isNaN(total) ? "-" : total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    mounted() {},

    methods: {
        hourKeypressHandler: function(evt) {
            let charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
                return false;
            }

            return true;
        },

        nextClickHandler() {
            let data = {
                estimatedNumOfHours: this.numOfHours,
                estimatedTotal: `$${this.total}`
            };

            this.onResponse({
                data,
                response: true
            });
        }
    }
  };
</script>
